import { Breadcrumb, Button } from "antd";
import axios from "axios";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ActionBar from "../../components/action-bar";
import ActionButton from "../../components/action-button";
import FlexCard from "../../components/flex-card";
import MiniTable from "../../components/mini-table";
import AuthenticatedLayout from "../../layouts/authenticated";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import ModeloDrawer from "./_ModeloDrawer";
import ModelosTable from "./_ModelosTable";
import { useSelector } from "react-redux";
import { isDiretorSelector, nivelAcessoSelector } from "../../store/autenticacao";

export default function ModelosPage() {
  const miniTableRef = useRef();
  const { t } = useTranslation();
  const [loadingSearch, setLoadingSearch] = useState(false);
  const nivelAcesso = useSelector(nivelAcessoSelector);
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [loadingDrawer, setLoadingDrawer] = useState(false);
  const [activeSearch, setActiveSearch] = useState();
  const [personalizado, setPersonalizado] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [modelo, setModelo] = useState();
  const [ModeloDrawerVisible, setModeloDrawerVisible] = useState(false);

  const handleSearch = (search, personalizado = false) => {
    setLoadingSearch(true);
    unwrapAxiosPromise(axios.get("/modelos", { params: { search, personalizado } }))
      .then((data) => {
        setActiveSearch(search);
        setDataSource(data);
      })
      .finally(() => setLoadingSearch(false));
  };

  const handleCreateClick = () => {
    setModelo(undefined);
    setModeloDrawerVisible(true);
  };

  const handleRemove = () => {
    setLoadingRemove(true);
    unwrapAxiosPromise(axios.delete("/modelos", { params: { ids: selectedIds } }))
      .then(() => {
        setSelectedIds([]);
        handleSearch(activeSearch, personalizado);
      })
      .finally(() => setLoadingRemove(false));
  };

  const fetchModelosPersonalizado = ({ personalizado }) => {
    setPersonalizado(personalizado);
    handleSearch(activeSearch || "", personalizado);
  };

  const handleClick = (modelo) => {
    setModeloDrawerVisible(true);
    setModelo(modelo);
  };

  const handleModeloChange = () => {
    handleSearch(activeSearch, personalizado);
  };

  const handleModeloDrawerClose = () => {
    setModeloDrawerVisible(false);
  };

  const handleModeloDrawerAfterClose = () => {
    setModelo(undefined);
  };

  const title = () => {
    return (
      <ActionBar onSearch={(search) => handleSearch(search, personalizado)}>
        {!(personalizado === false && nivelAcesso === 5) && <ActionButton.Create onClick={handleCreateClick} />}

        <ActionButton.Remove disabled={selectedIds.length === 0} onClick={handleRemove} loading={loadingRemove} />
        <MiniTable.DownloadButton disabled={loadingSearch || loadingRemove || dataSource.length === 0} miniTableRef={miniTableRef} />
      </ActionBar>
    );
  };

  return (
    <AuthenticatedLayout breadcrumb={[t("Modelos")]}>
      <Breadcrumb>
        <Breadcrumb.Item>{t("Modelos")}</Breadcrumb.Item>
      </Breadcrumb>
      <FlexCard>
        <ModelosTable
          dataSource={dataSource}
          loading={loadingSearch || loadingRemove}
          miniTableRef={miniTableRef}
          onClick={handleClick}
          onSelectedIdsChange={setSelectedIds}
          selectedIds={selectedIds}
          title={title}
          fetchModelosPersonalizado={fetchModelosPersonalizado}
          personalizado={personalizado}
          setPersonalizado={setPersonalizado}
        />
      </FlexCard>
      <ModeloDrawer loading={loadingDrawer} onAfterClose={handleModeloDrawerAfterClose} onChange={handleModeloChange} onClose={handleModeloDrawerClose} value={modelo} visible={ModeloDrawerVisible} personalizado={personalizado} />
    </AuthenticatedLayout>
  );
}
